/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders icon and text if none job is selected on job search.
 */

import React from 'react';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { SearchLocationsIcon } from '~/vcl/icons/SearchLocations';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import { Slottable } from './interfaces';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <>
      <EmptyElement icon={<SearchLocationsIcon width="180" height="180" />}>
        <Spacing />
        <div>
          <RichFormattedMessage
            id="job_detail_panel_instructions"
            defaultMessage="To see all the details of a job posting please choose one from the list on the left."
          />
        </div>
      </EmptyElement>
    </>
  );
};
export default JobSearchEmptySlot;
